import React from 'react';

type Props = {
  playId: string;
};

const CancelPageReports: React.FC<Props> = ({ playId }) => {
  return (
    <div>
      Unified Play Cancel Page Reporting Dashboard for Play ID: {playId}
    </div>
  );
};

export default CancelPageReports;
